// Constants
import { FOLDERABLE_APP_CONFIG } from 'FoldersApp/constants/folderable-app-config.constants';
// Services
import { SharingService } from 'SharingApp/ts/services/sharing.service';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
// Components
import { FolderOperationsDropdownComponent } from 'FoldersApp/features/folders-shared/folder-operations-dropdown/folder-operations-dropdown.component';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i2 from "SharingApp/ts/services/sharing.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i6 from "FoldersApp/features/folders-shared/folder-operations-dropdown/folder-operations-dropdown.component";
import * as i7 from "FoldersApp/features/folders-shared/set-view-root-folder/set-view-root-folder.directive";
import * as i8 from "../../../../../sharing/static/sharing/ts/pipes/get-sharing-tooltip-message.pipe";
import * as i9 from "../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
const _c0 = ["folderOperationsDropdown"];
const _c1 = a0 => ({ "visible-md-flex": a0 });
const _c2 = a0 => ({ "view-root": a0 });
const _forTrack0 = ($index, $item) => $item.id;
function FolderBreadcrumbComponent_For_5_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4);
    i0.ɵɵelement(1, "a", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", "...")("folderId", item_r1.id);
} }
function FolderBreadcrumbComponent_For_5_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4);
    i0.ɵɵelement(1, "a", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", item_r1.name)("folderId", item_r1.id);
} }
function FolderBreadcrumbComponent_For_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FolderBreadcrumbComponent_For_5_Conditional_0_Template, 2, 2, "li", 4)(1, FolderBreadcrumbComponent_For_5_Conditional_1_Template, 2, 2, "li", 4);
} if (rf & 2) {
    const ɵ$index_9_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ɵ$index_9_r2 === 0 && ctx_r2.folderableCollectionService.viewRootFolder.ancestors.length === ctx_r2.maxDisplayedAncestors ? 0 : 1);
} }
function FolderBreadcrumbComponent_Conditional_6_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵpipe(1, "getSharingTooltipMessage");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", i0.ɵɵpipeBind1(1, 4, ctx_r2.folderableCollectionService.viewRootFolder));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-team");
} }
function FolderBreadcrumbComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 8, 0);
    i0.ɵɵlistener("click", function FolderBreadcrumbComponent_Conditional_6_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.toggleDropdown()); });
    i0.ɵɵelement(2, "div", 9);
    i0.ɵɵtemplate(3, FolderBreadcrumbComponent_Conditional_6_Conditional_3_Template, 3, 6, "div", 10);
    i0.ɵɵpipe(4, "isSharedWithOthers");
    i0.ɵɵelementStart(5, "div", 11);
    i0.ɵɵelement(6, "ycn-folder-operations-dropdown", 12, 1);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const folderOperationsDropdownToggle_r5 = i0.ɵɵreference(1);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r2.folderableCollectionService.viewRootFolder.name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(4, 9, ctx_r2.folderableCollectionService.viewRootFolder) ? 3 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("externalToggle", folderOperationsDropdownToggle_r5)("item", ctx_r2.folderableCollectionService.viewRootFolder)("folderIsDisabled", false)("resourceType", ctx_r2.FolderItemType.FOLDER)("resourceTypeDescription", "folder")("listItemView", false)("ancestorFolderId", ctx_r2.ancestorFolderId);
} }
/**
 * Component for breadcrumb of folder links.
 * - Show the current folder and its ancestors (if there are any).
 * - Used to navigate to a parent folder and see how deep in the folder hierarchy the user is.
 *
 * Example Format:
 * - My YCharts > ... > Folder 3 > Folder 4 > Folder 5
 */
export class FolderBreadcrumbComponent {
    get ancestorFolderId() {
        const ancestors = this.folderableCollectionService.viewRootFolder?.ancestors;
        return ancestors === undefined || ancestors.length <= 0 ? null : ancestors[ancestors.length - 1].id;
    }
    constructor(folderableAppConfig, folderableCollectionService, sharingService) {
        this.folderableAppConfig = folderableAppConfig;
        this.folderableCollectionService = folderableCollectionService;
        this.sharingService = sharingService;
        // The maximum number of ancestor folders that can be displayed in the breadcrumb.
        // Note: this does not include My YCharts.
        this.maxDisplayedAncestors = 3;
        this.FolderItemType = FolderableType;
        this.displayFlex = false;
    }
    toggleDropdown() {
        this.folderOperationsDropdown.toggleDropdown();
    }
}
FolderBreadcrumbComponent.ɵfac = function FolderBreadcrumbComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderBreadcrumbComponent)(i0.ɵɵdirectiveInject(FOLDERABLE_APP_CONFIG), i0.ɵɵdirectiveInject(i1.FolderableCollectionServiceBase), i0.ɵɵdirectiveInject(i2.SharingService)); };
FolderBreadcrumbComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderBreadcrumbComponent, selectors: [["ycn-folder-breadcrumb"]], viewQuery: function FolderBreadcrumbComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.folderOperationsDropdown = _t.first);
    } }, inputs: { displayFlex: "displayFlex" }, standalone: false, decls: 7, vars: 9, consts: [["folderOperationsDropdownToggle", ""], ["folderOperationsDropdown", ""], [1, "mr-1", 3, "ngClass"], [1, "file-path"], [1, "file-path-item"], ["href", "javascript:void(0)", "ycn-set-view-root-folder", "", 1, "file-path-title", 3, "ngClass", "textContent", "folderId"], [1, "file-path-item", "cursor-pointer"], ["href", "javascript:void(0)", "ycn-set-view-root-folder", "", 1, "file-path-title", 3, "textContent", "folderId"], [1, "file-path-item", "cursor-pointer", 3, "click"], [1, "file-path-title", "view-root", 3, "textContent"], ["ycnTooltip", "", 1, "filepath-title", "btn", "btn-circle", "btn-share", "btn-transparent", "btn-xs", "ml-1", "btn-transparent3", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle"], [1, "dropdown", "ml-1"], [3, "externalToggle", "item", "folderIsDisabled", "resourceType", "resourceTypeDescription", "listItemView", "ancestorFolderId"], ["ycnIcon", "", 3, "name"]], template: function FolderBreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 2)(1, "ul", 3)(2, "li", 4);
        i0.ɵɵelement(3, "a", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵrepeaterCreate(4, FolderBreadcrumbComponent_For_5_Template, 2, 1, null, null, _forTrack0);
        i0.ɵɵtemplate(6, FolderBreadcrumbComponent_Conditional_6_Template, 8, 11, "li", 6);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1, ctx.displayFlex));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c2, (ctx.folderableCollectionService.viewRootFolder == null ? null : ctx.folderableCollectionService.viewRootFolder.id) === null))("textContent", ctx.folderableAppConfig.itemNamePlural || "My YCharts")("folderId", null);
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.folderableCollectionService.viewRootFolder == null ? null : ctx.folderableCollectionService.viewRootFolder.ancestors);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.viewRootFolder && ctx.folderableCollectionService.viewRootFolder.id ? 6 : -1);
    } }, dependencies: [i3.NgClass, i4.IconDirective, i5.TooltipDirective, i6.FolderOperationsDropdownComponent, i7.SetViewRootFolderDirective, i8.GetSharingTooltipMessage, i9.IsSharedWithOthersPipe], encapsulation: 2 });
